import ReleaseAssetFan from '@/components/marketing/technology/ReleaseAssetFan'
import TechnologySubPage from '@/components/marketing/technology/TechnologySubPage'
import type { TechnologySubPageProps } from '@/types/technology'

/* The technology section — the Creative & audience page.
 *
 * All the sub-pages share one layout and differ only in the props
 * TechnologyController builds from TechnologyContent. This file exists because
 * the marketing entrypoint resolves `render inertia: "technology/Creative"`
 * against this exact path — it is the route, not a place for page-specific
 * markup.
 *
 * The one exception is `visual`. A list of nine creative tools reads as nine
 * products to buy and wire together; drawing them as nine things that fall out
 * of one release record is the actual claim, and the shape carries it in a way
 * a paragraph does not.
 */
export default function Creative(props: TechnologySubPageProps) {
  return <TechnologySubPage {...props} visual={<ReleaseAssetFan />} />
}
